import { createFileRoute } from '@tanstack/react-router';
import { TicketingPage } from '../../features/ticketing/TicketingPage.jsx';

function TicketingRoute() {
  const { eventId } = Route.useParams();
  return <TicketingPage key={eventId} eventId={eventId} />;
}

export const Route = createFileRoute('/_app/ticketing/$eventId')({ component: TicketingRoute });
